import {Component, Input} from '@angular/core';


/**
 * A component that renders an SVG icon for "Playlist Plus"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-playlist-plus',
    templateUrl: './icon-playlist-plus.component.html',
    styleUrls: ['./icon-playlist-plus.component.scss'],
    standalone: false
})
export class IconPlaylistPlusComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
